import {createTheme} from "@mui/material/styles";
import {huHU} from "@mui/material/locale";
import typography from "./Typography";
import {components} from "./ComponentDef";


const honvedColors = {
    '900': '#300406',
    '800': '#43070a',
    '700': '#630a0e',
    'A700': '#8a0e14',
    '600': '#c1131c',
    '500': '#EB1722',
    '400': '#EB1722',
    'A400': '#e6222d',
    '300': '#ec444d',
    '200': '#e65a61',
    'A200': '#e36b72',
    '100': '#e6797f',
    'A100': '#d6757a',
    '50': '#e69196',
    '20': '#eaacae',
}

const honvedTheme = createTheme({
        components: components,
        palette: {
            primary: honvedColors,
            secondary: honvedColors,
        },
        name: 'blue',
        typography: typography
    },
    huHU
)

export default honvedTheme